
import React from 'react';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { FileSpreadsheet, Upload, X, Loader2 } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface CategoryPreviewProps {
  categories: string[];
  isPending: boolean;
  onUpload: () => void;
  onReset: () => void;
}

export const CategoryPreview: React.FC<CategoryPreviewProps> = ({
  categories,
  isPending,
  onUpload,
  onReset
}) => {
  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium flex items-center">
          <FileSpreadsheet className="inline mr-2" size={18} />
          Preview Categories
          <Badge className="ml-2" variant="outline">{categories.length}</Badge>
        </h3>
        <div className="space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onReset}
            disabled={isPending}
          >
            <X className="h-4 w-4 mr-1" />
            Reset
          </Button>
          <Button
            size="sm"
            onClick={onUpload}
            disabled={isPending || categories.length === 0}
          >
            {isPending ? (
              <>
                <Loader2 className="h-4 w-4 mr-1 animate-spin" />
                Uploading...
              </>
            ) : (
              <>
                <Upload className="h-4 w-4 mr-1" />
                Upload Categories
              </>
            )}
          </Button>
        </div>
      </div>

      {categories.length > 0 ? (
        <Card className="overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>#</TableHead>
                <TableHead>Category Name (from "name" column)</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {categories.map((category, index) => (
                <TableRow key={index}>
                  <TableCell className="w-12 font-mono text-muted-foreground">{index + 1}</TableCell>
                  <TableCell>{category}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      ) : null}
    </div>
  );
};
